import i18n from '../../language/index'
import linkData from '@/base/linkData'
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  pc_infor:{
    marginTop:'2.5%',
    marginLeft:'0',
    marginRight:'0',
    marginBottom:'2.5%',
    textAlign: 'center'
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    height: 40,
    fontStyle: {
      radio_val: 'custom',
      default: {
        lineHeight: i18n.t('view_back_top_edit_103'),
        fontSize: 30,
        fsWeight: 'normal',
        fsItalics: 'normal',
        fontStyle: '',
        fontUnderline: 'none',
        fontFamily: 'Arial',
        titleColor: 'rgba(51, 51, 51,1)',
        textAlign: 'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        lineHeight: i18n.t('view_back_top_edit_103'),
        fontSize: 30,
        fsWeight: 'normal',
        fsItalics: 'normal',
        fontStyle: '',
        fontUnderline: 'none',
        fontFamily: 'Arial',
        titleColor: 'rgba(51, 51, 51,1)',
        textAlign: 'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    marginValue: {
      radio_val: 'default',
      default: {
        value: 20
      },
      custom: {
        value: 10,
      }
    },
    imgMarginleft: 10,
    imgMarginright: 0,
    typeValue: 'type_0', //当前选的是那种标题样式
    pattern2: 'linear_gradient',
    pattern3: 'pure_color',
    selectValue1: 'default'
  },
  mb_widgets_infor: {},
  listArr: {
    url: '',
    link: '',
    logoUrl: '',
    logoTitle: '',
    title: i18n.t('view_left_sidebar_setting_279'),
    link_text: linkData,
    link_pic: linkData,
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_webtitle/style.js